import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const IconProviderPlatipus = ({ className }) => (
  <svg className={classNames('producers-svg-icon', className)} width="22" height="22" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#icon-provider-platipus)">
      <path d="M24 0V22.2251C24 23.1897 23.7303 24 23.3798 24H0.620225C0.269663 24 0 23.1897 0 22.2251V5.71061C0 4.74598 0.269663 3.97428 0.620225 3.97428H22.5978L23.8787 0H24Z" fill="#EB5149" />
      <path d="M17 12.3162C17 14.83 15.0198 16.6798 12.3465 16.6798H10.4653V20H7V8H12.3465C15.0198 8 17 9.80237 17 12.3162ZM13.4356 12.3162C13.4356 11.4625 12.8416 10.8933 11.9505 10.8933H10.4653V13.7866H11.9505C12.8416 13.7866 13.4356 13.17 13.4356 12.3162Z" fill="white" />
    </g>
  </svg>
);

IconProviderPlatipus.propTypes = {
  className: PropTypes.string
};

IconProviderPlatipus.defaultProps = {
  className: ''
};
